<template>
  <div class="se-coming-soon">
    <div class="se-coming-soon-icon">⚙️</div>
    <div class="se-coming-soon-title">Behavior — coming soon</div>
    <div class="se-coming-soon-text">Conditional routing, validation rules, and processing-function config for this stage will live here.</div>
  </div>
</template>

<script>
export default {
  name: 'stage-behavior-tab'
}
</script>

<style scoped>
.se-coming-soon{padding:24px 4px;text-align:center}
.se-coming-soon-icon{font-size:26px;margin-bottom:10px;opacity:0.6}
.se-coming-soon-title{font-size:12.5px;font-weight:600;color:var(--text);margin-bottom:6px}
.se-coming-soon-text{font-size:11.5px;color:var(--text-faint);line-height:1.5}
</style>



// WEBPACK FOOTER //
// StageBehaviorTab.vue?b350c1b2